import { Component, OnInit } from '@angular/core';
import { ApplicationService } from 'app/services/application.service';

@Component({
  selector: 'approval-manager',
  templateUrl: './approval-manager.component.html',
  styleUrls: ['./approval-manager.component.css']
})
export class ApprovalManagerComponent implements OnInit {

  ctrlData: any = { carrierId: 0, permitId: 0, currentActive: 1, action: 0, ctrlAction: 0, data:{ }};  
  constructor() { }

  ngOnInit() {
    
  } 
  
}
